export enum DPFormType {
  Electronic = 1,
  PDF = 2,
  MultiPDFForm = 3,
}
